import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Panel from '../../components/common/Panel';
import CountTop from '../../components/common/CountTop';
import ActionLinkTop from '../../components/common/ActionLinkTop';
import DropDownFilter from '../../components/filters/DropDownFilter';
import { productsFilter } from '../../constants/filters';
import SortOrderFilter from '../../components/filters/SortOrderFilter';
import Wall from '../../components/common/Wall';
import PageLayout from '../../components/common/PageLayout';
import ProductsReplenishContainer from '../blocks/ProductsReplenishContainer';
import {
  productsReplenishCheckAllOnPage,
  productsReplenishCheckAll,
  productsReplenishUncheckAll,
  setProductsReplenishOrderField,
  setProductsReplenishOrder,
} from '../../store/actions/productsReplenish';

function ProductsReplenishPageContainer(props) {
  const { unselectAll } = props;

  useEffect(() => {
    return () => {
      unselectAll();
    };
  }, [unselectAll]);

  const selectAllOnPage = () => {
    const selected = {};
    props.products.forEach((item) => {
      selected[item.model] = item.variants;
    });
    props.selectAllOnPage(selected);
  };

  const panel = (
    <Panel>
      <Wall />
      <CountTop title="All" count={props.productsCount} />
      <CountTop title="Selected" count={props.selectedCount} />
      <Wall />
      <ActionLinkTop title="Select this page" onClick={selectAllOnPage} />
      <ActionLinkTop title="Select all" onClick={props.selectAll} />
      <ActionLinkTop title="Unselect all" onClick={unselectAll} />
      <Wall />
      <DropDownFilter values={productsFilter} onChange={props.setProductsOrderField} staticPoint />
      <Wall />
      <SortOrderFilter onChange={props.setProductsOrder} />
      <Wall />
    </Panel>
  );

  return (
    <PageLayout top={panel}>
      <div className="top">
        <ProductsReplenishContainer />
      </div>
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { data, checked, count } = state.productsReplenish;

  return {
    productsCount: +count,
    selectedCount: Object.keys(checked).length,
    products: data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  selectAllOnPage: (ids) => dispatch(productsReplenishCheckAllOnPage(ids)),
  selectAll: () => dispatch(productsReplenishCheckAll()),
  unselectAll: () => dispatch(productsReplenishUncheckAll),
  setProductsOrder: (order) => dispatch(setProductsReplenishOrder(order)),
  setProductsOrderField: (field) => dispatch(setProductsReplenishOrderField(field)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsReplenishPageContainer);

ProductsReplenishPageContainer.propTypes = {
  productsCount: PropTypes.number.isRequired,
  selectedCount: PropTypes.number.isRequired,
  selectAll: PropTypes.func.isRequired,
  unselectAll: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  setProductsOrderField: PropTypes.func.isRequired,
  setProductsOrder: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  selectAllOnPage: PropTypes.func.isRequired,
};
